export const AnyXCSSSpinner = () => (
  <div className="flex h-6 w-6 flex-wrap">
    <span className="animate-spinner-blue h-1/2 w-1/2 origin-top-left rounded-full bg-[#436cb0]" />
    <span className="animate-spinner-red h-1/2 w-1/2 origin-top-right rounded-bl-none rounded-[50%] bg-[#ed2f36]" />
    <span className="animate-spinner-green h-1/2 w-1/2 origin-bottom-left rounded-tr-none rounded-[50%] bg-[#4bad4e]" />
    <span className="animate-spinner-yellow h-1/2 w-1/2 origin-bottom-right rounded-full bg-[#f3c724]" />
  </div>
);
